import * as PropTypes from 'prop-types';

import {Collaborator} from 'auth/PermissionConstants';
import {NavStoreProject} from 'constants/SourceConstants';

export interface SectionFilter {
  id: string | null;
  name: string;
}

export interface Section {
  collapsed: boolean;
  id: string;
  name: string;
  showTitle: boolean;
  filterFn?: (source: NavStoreProject, currentFilter: SectionFilter) => Array<Collaborator>;
  sortFn?: (source: NavStoreProject) => number;
  filterOptions?: Array<SectionFilter>;
  renderEmptySection?: (currentFilter: SectionFilter) => JSX.Element;
}

export enum ProjectAttributeFilterValue {
  ALL_ACTIVE = 'ALL_ACTIVE',
  STARRED = 'STARRED',
  HIDDEN = 'HIDDEN',
  ARCHIVED = 'ARCHIVED',
}

export const ProjectPreferences = {
  LAST_SELECTED_PROJECT_FILTER: 'projects.lastProjectFilter',
  SECTION_COLLAPSED: 'project_section_collapsed',
  LAST_SELECTED_PROJECT_ATTRIBUTE_FILTER: 'projects.lastAttributeFilter',
};

export const SECTION_SHAPE = PropTypes.shape({
  collapsed: PropTypes.bool.isRequired,
  // Takes (source, currentFilter) as parameters,
  // returns true if `source` should be included in the filter
  filterFn: PropTypes.func,
  // List of filters that can be used to filter this section
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  // Takes (currentFilter) as a parameter, returns a React node
  renderEmptySection: PropTypes.func,
});
